const STORAGE_KEY = 'canparkAdmin.lastSelection';

export interface CanparkAdminLastSelection {
	customerId?: string;
}

export const readCanparkAdminLastSelection = (): CanparkAdminLastSelection => {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};

export const writeCanparkAdminLastSelection = (
	patch: CanparkAdminLastSelection
): void => {
	try {
		const merged = { ...readCanparkAdminLastSelection(), ...patch };
		localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
	} catch {
		// localStorage may be unavailable (private mode, quota); ignore.
	}
};
